const initialState = {
	loading: false,
	error: null
}

const misc = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_CHARGE':
			return { ...state, loading: true, error: null }
		case 'ADD_CHARGE_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while creating charge/credit.'
			}
		default:
			return state
	}
}

export default misc
